import type { AgentConversationSnapshot } from 'services/agent/page-context';

/** 与 perseus 对齐：白名单读取，保留最近消息，排除草稿、原始报文及媒体地址。 */
export function conversationAgentContext(
  conversation: Conversation.Conversation,
  messages: Conversation.Message[],
  stream: AgentConversationSnapshot['stream'],
): AgentConversationSnapshot {
  let truncated = messages.length > 100;
  const clip = (value: string, limit = 2000) => {
    if (value.length > limit) truncated = true;
    return value.slice(0, limit);
  };
  const selected: AgentConversationSnapshot['messages'] = [];
  let remaining = 60000;
  for (const message of messages.slice(-100).reverse()) {
    let text = '';
    if (message.status !== 'RECALL') {
      switch (message.messageType) {
        case 'TEXT':
          text = message.textContent?.text || '';
          break;
        case 'IMAGE_WITH_TEXT':
          text = message.imageWithTextContent?.text || '';
          break;
        case 'TEXT_VIDEO':
          text = message.textVideoContent?.textContent.text || '';
          break;
        case 'FACEBOOK_MESSAGE':
          text = message.fbMsgContent?.message || '';
          break;
      }
    }
    const value: AgentConversationSnapshot['messages'][number] = {
      msgId: clip(message.msgId, 160),
      from:
        message.msgFromType === 'BUYER' || message.msgFromType === 'MERCADO2ASSISTANT'
          ? 'buyer'
          : message.msgFromType === 'BOT'
          ? 'bot'
          : message.msgFromType === 'SYSTEM'
          ? 'system'
          : 'assistant',
      at: clip(String(message.sendTime), 80),
      kind: clip(message.messageType, 80),
      text: clip(text),
      status: message.status,
    };
    remaining -= JSON.stringify(value).length;
    if (remaining < 0) {
      truncated = true;
      break;
    }
    selected.push(value);
  }
  const result: AgentConversationSnapshot = {
    conversationId: clip(conversation.conversationId, 160),
    platform: conversation.channel,
    shopId: clip(conversation.storeId, 160),
    region: conversation.region,
    buyer: { nickname: clip(conversation.buyerNick || '', 200) },
    stream,
    scope: 'loadedMessages',
    truncated,
    messages: selected.reverse(),
  };
  return result;
}
